var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _vm.showActions === true
        ? _c(
            "el-form",
            {
              staticClass: "mb-10",
              attrs: { inline: "" },
              nativeOn: {
                submit: function($event) {
                  $event.preventDefault()
                }
              }
            },
            [
              _c(
                "el-button",
                {
                  attrs: {
                    disabled:
                      !_vm.propsColumns.manualActionPossible ||
                      _vm.selectedInvoiceReferences.length === 0,
                    type: "primary",
                    size: "mini"
                  },
                  on: { click: _vm.handleCreatePhoneAction }
                },
                [
                  _c("span", [
                    _vm._v(_vm._s(_vm.$t("actions.button.create_phone_action")))
                  ])
                ]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: {
                    size: "mini",
                    type: "primary",
                    disabled: _vm.selectedInvoiceReferences.length === 0
                  },
                  on: { click: _vm.handlePlanManualAction }
                },
                [
                  _vm._v(
                    "\n\t\t\t" +
                      _vm._s(
                        _vm.$t("manual_action.button.plan_manual_action")
                      ) +
                      "\n\t\t"
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "el-tooltip",
                {
                  staticClass: "item",
                  attrs: {
                    effect: "dark",
                    content: _vm.$t("sendCopyInvoice"),
                    placement: "top"
                  }
                },
                [
                  _c(
                    "span",
                    [
                      _c(
                        "el-button",
                        {
                          attrs: {
                            disabled:
                              _vm.selectedInvoices == undefined
                                ? true
                                : _vm.selectedInvoices.length < 1,
                            type: "primary",
                            size: "mini",
                            loading: _vm.sendInvoiceCopyEmailloading
                          },
                          on: { click: _vm.handleSendInvoiceCopyEmail }
                        },
                        [
                          _c("svg-icon", {
                            staticStyle: { color: "#fff", "font-size": "11px" },
                            attrs: { "icon-class": "file-invoice-solid" }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "el-tooltip",
                {
                  staticClass: "item",
                  attrs: {
                    effect: "dark",
                    content: _vm.$t("actions.tooltip.send_copy_invoice_mail"),
                    placement: "top"
                  }
                },
                [
                  _c(
                    "span",
                    [
                      _c(
                        "el-button",
                        {
                          attrs: {
                            disabled:
                              _vm.selectedInvoices == undefined
                                ? true
                                : _vm.selectedInvoices.length != 1 ||
                                  !_vm.singleSelectedInvoiceHasReference,
                            type: "primary",
                            size: "mini",
                            loading: _vm.sendInvoiceCopyMailloading
                          },
                          on: { click: _vm.handleSendInvoiceCopyMail }
                        },
                        [
                          _c("svg-icon", {
                            staticStyle: { color: "#fff", "font-size": "11px" },
                            attrs: { "icon-class": "file-invoice-solid" }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "el-tooltip",
                {
                  staticClass: "item",
                  attrs: {
                    effect: "dark",
                    content: _vm.$t("InvoiceTable.send_account_overview_email"),
                    placement: "top"
                  }
                },
                [
                  _c(
                    "span",
                    [
                      _c("el-button", {
                        attrs: {
                          icon: "el-icon-document-copy",
                          type: "primary",
                          size: "mini",
                          loading: _vm.sendAccountOverviewActionEmailLoading
                        },
                        on: { click: _vm.handleSendAccountOverviewEmail }
                      })
                    ],
                    1
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "el-tooltip",
                {
                  staticClass: "item",
                  attrs: {
                    effect: "dark",
                    content: _vm.$t("InvoiceTable.send_account_overview_sms"),
                    placement: "top"
                  }
                },
                [
                  _c(
                    "span",
                    [
                      _c("el-button", {
                        attrs: {
                          icon: "el-icon-document-copy",
                          type: "primary",
                          size: "mini",
                          loading: _vm.sendAccountOverviewActionSmsLoading
                        },
                        on: { click: _vm.handleSendAccountOverviewSms }
                      })
                    ],
                    1
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "el-tooltip",
                {
                  staticClass: "item",
                  attrs: {
                    effect: "dark",
                    content: _vm.$t("InvoiceTable.dispute_invoice"),
                    placement: "top"
                  }
                },
                [
                  _c(
                    "span",
                    [
                      _c(
                        "el-button",
                        {
                          attrs: {
                            disabled:
                              _vm.selectedInvoices &&
                              _vm.selectedInvoices.length == 0,
                            type: "primary",
                            size: "mini"
                          },
                          on: { click: _vm.handleDisputeInvoices }
                        },
                        [
                          _c("svg-icon", {
                            staticStyle: { color: "#fff", "font-size": "11px" },
                            attrs: { "icon-class": "bug" }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ]
              ),
              _vm._v(" "),
              _vm.disablePaymentPlanReason
                ? [
                    _c(
                      "el-tooltip",
                      {
                        staticClass: "item",
                        attrs: {
                          effect: "dark",
                          content: _vm.disablePaymentPlanReason,
                          placement: "top"
                        }
                      },
                      [
                        _c(
                          "span",
                          [
                            _c(
                              "el-button",
                              {
                                attrs: {
                                  type: "primary",
                                  size: "mini",
                                  disabled: _vm.disablePaymentPlan
                                },
                                on: {
                                  click: _vm.handleCreatePaymentPlanButtonClick
                                }
                              },
                              [
                                _vm._v(
                                  " " + _vm._s(_vm.$t("create_payment_plan"))
                                )
                              ]
                            )
                          ],
                          1
                        )
                      ]
                    )
                  ]
                : [
                    _c(
                      "el-button",
                      {
                        attrs: {
                          type: "primary",
                          size: "mini",
                          disabled: _vm.disablePaymentPlan
                        },
                        on: { click: _vm.handleCreatePaymentPlanButtonClick }
                      },
                      [_vm._v(" " + _vm._s(_vm.$t("create_payment_plan")))]
                    )
                  ],
              _vm._v(" "),
              _vm.participant && _vm.showManualAttachmentButton
                ? _c(
                    "el-button",
                    {
                      attrs: {
                        type: "primary",
                        size: "mini",
                        loading: _vm.manualAttachmentLoading
                      },
                      on: { click: _vm.handleManualAttachmentButtonClick }
                    },
                    [
                      _vm._v(
                        " " + _vm._s(_vm.$t("InvoiceTable.manual_attachment"))
                      )
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm._l(
                _vm.userInterfaceDetails.custom_recipient_actions,
                function(customAction) {
                  return _c(
                    "div",
                    { key: customAction.endpoint },
                    [
                      _c(
                        "el-tooltip",
                        {
                          staticClass: "item",
                          attrs: {
                            effect: "dark",
                            content: customAction.label[_vm.$i18n.locale],
                            placement: "top"
                          }
                        },
                        [
                          _c("el-button", {
                            attrs: {
                              type: "primary",
                              size: "mini",
                              icon: customAction.icon
                            },
                            on: {
                              click: function($event) {
                                return _vm.handleCustomRecipientActionClick(
                                  _vm.fullRecipient,
                                  customAction
                                )
                              }
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                }
              )
            ],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.showFilters === true
        ? _c(
            "div",
            { staticClass: "ml-auto" },
            [
              _c(
                "el-form",
                {
                  attrs: { inline: "" },
                  nativeOn: {
                    submit: function($event) {
                      $event.preventDefault()
                    }
                  }
                },
                [
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "el-select",
                        {
                          attrs: {
                            "collapse-tags": "",
                            multiple: "",
                            size: "mini",
                            placeholder: _vm.$t("statusFilter")
                          },
                          model: {
                            value: _vm.status,
                            callback: function($$v) {
                              _vm.status = $$v
                            },
                            expression: "status"
                          }
                        },
                        _vm._l(
                          _vm.CONSTANTS.INVOICETABLE_DEFAULT_STATUS_LIST,
                          function(item) {
                            return _c("el-option", {
                              key: item,
                              attrs: {
                                label: _vm.$translate.invoice_status(item),
                                value: item
                              }
                            })
                          }
                        ),
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "el-select",
                        {
                          attrs: {
                            "collapse-tags": "",
                            multiple: "",
                            size: "mini",
                            placeholder: _vm.$t("document_type_filter")
                          },
                          model: {
                            value: _vm.documentType,
                            callback: function($$v) {
                              _vm.documentType = $$v
                            },
                            expression: "documentType"
                          }
                        },
                        _vm._l(_vm.documentTypes, function(item) {
                          return _c("el-option", {
                            key: item,
                            attrs: {
                              label: _vm.$translate.document_type(item),
                              value: item
                            }
                          })
                        }),
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    [
                      _c("el-date-picker", {
                        attrs: {
                          size: "mini",
                          type: "daterange",
                          align: "right",
                          "unlink-panels": "",
                          "range-separator": "-",
                          "start-placeholder": _vm.$t("startDate"),
                          "end-placeholder": _vm.$t("endDate"),
                          "picker-options": _vm.pickerOptions,
                          format: "dd-MM-yyyy"
                        },
                        model: {
                          value: _vm.dateRange,
                          callback: function($$v) {
                            _vm.dateRange = $$v
                          },
                          expression: "dateRange"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary", size: "mini" },
                          on: { click: _vm.applyFilters }
                        },
                        [
                          _vm._v(
                            "\n\t\t\t\t\t" +
                              _vm._s(_vm.$t("applyFilters")) +
                              "\n\t\t\t\t"
                          )
                        ]
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "el-input",
                        {
                          attrs: { size: "mini", placeholder: "" },
                          nativeOn: {
                            keyup: function($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              )
                                return null
                              return _vm.onSearch.apply(null, arguments)
                            }
                          },
                          model: {
                            value: _vm.searchTerm,
                            callback: function($$v) {
                              _vm.searchTerm = $$v
                            },
                            expression: "searchTerm"
                          }
                        },
                        [
                          _c("i", {
                            staticClass: "el-input__icon el-icon-search",
                            attrs: { slot: "prefix" },
                            slot: "prefix"
                          })
                        ]
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary", size: "mini" },
                          on: { click: _vm.onSearch }
                        },
                        [
                          _vm._v(
                            "\n\t\t\t\t\t" +
                              _vm._s(_vm.$t("search")) +
                              "\n\t\t\t\t"
                          )
                        ]
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary", size: "mini" },
                          on: { click: _vm.onReset }
                        },
                        [_vm._v(" Reset ")]
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _vm.userInterfaceDetails &&
              _vm.userInterfaceDetails.custom_field_definitions &&
              _vm.userInterfaceDetails.custom_field_definitions.filter(
                field => field.searchable
              ).length > 0
                ? _c(
                    "el-collapse",
                    {
                      model: {
                        value: _vm.customFieldsFiltersVisible,
                        callback: function($$v) {
                          _vm.customFieldsFiltersVisible = $$v
                        },
                        expression: "customFieldsFiltersVisible"
                      }
                    },
                    [
                      _c(
                        "el-collapse-item",
                        {
                          attrs: {
                            title: _vm.$t("custom_fields_filters"),
                            name: "1"
                          }
                        },
                        [
                          _c("custom-fields-filters", {
                            key: _vm.customFieldsFiltersKey,
                            ref: "customFieldsFilters",
                            attrs: {
                              "custom-field-definitions": _vm.userInterfaceDetails.custom_field_definitions.filter(
                                field => field.searchable
                              ),
                              change: _vm.handleCustomFiltersChange
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "el-table",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading"
            }
          ],
          ref: "multipleTable",
          attrs: {
            "highlight-current-row": _vm.highlightCurrentRowProp,
            data: _vm.formattedData
          },
          on: {
            "selection-change": _vm.handleSelectionChange,
            "current-change": _vm.handleCurrentChange,
            "sort-change": _vm.onSortChange
          }
        },
        [
          _vm.propsColumns.selection === true
            ? _c("el-table-column", {
                attrs: { type: "selection", width: "48" }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.userInterfaceDetails.custom_actions &&
          _vm.userInterfaceDetails.custom_actions.length > 0
            ? _c("el-table-column", {
                attrs: {
                  width: _vm.userInterfaceDetails.custom_actions.length * 48
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function(scope) {
                        return _vm._l(
                          _vm.userInterfaceDetails.custom_actions,
                          function(customAction) {
                            return _c(
                              "div",
                              { key: customAction.endpoint },
                              [
                                _c(
                                  "el-tooltip",
                                  {
                                    staticClass: "item",
                                    attrs: {
                                      effect: "dark",
                                      content:
                                        customAction.label[_vm.$i18n.locale],
                                      placement: "top"
                                    }
                                  },
                                  [
                                    _c("el-button", {
                                      attrs: {
                                        type: "text",
                                        icon: customAction.icon
                                      },
                                      on: {
                                        click: function($event) {
                                          return _vm.handleCustomActionClick(
                                            scope.row,
                                            customAction
                                          )
                                        }
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          }
                        )
                      }
                    }
                  ],
                  null,
                  false,
                  3730848407
                )
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.propsColumns.deliveryDetails === true
            ? _c("el-table-column", {
                attrs: { "show-overflow-tooltip": "", prop: "", width: "48" },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function(scope) {
                        return [
                          "interchange_links" in scope.row
                            ? _c(
                                "div",
                                [
                                  _c("interchange-links", {
                                    attrs: {
                                      links: scope.row.interchange_links
                                    }
                                  })
                                ],
                                1
                              )
                            : _c("div", {
                                directives: [
                                  {
                                    name: "loading",
                                    rawName: "v-loading",
                                    value: true,
                                    expression: "true"
                                  }
                                ],
                                staticStyle: {
                                  "min-height": "20px",
                                  "margin-top": "17px",
                                  "font-size": "17px"
                                },
                                attrs: {
                                  "element-loading-spinner": "el-icon-loading",
                                  "element-loading-background":
                                    "rgba(0, 0, 0, 0)"
                                }
                              })
                        ]
                      }
                    }
                  ],
                  null,
                  false,
                  564638983
                )
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.propsColumns.invoiceNumber === true
            ? _c("el-table-column", {
                attrs: {
                  label: _vm.$t("documentNr"),
                  "show-overflow-tooltip": "",
                  prop: "document_number",
                  sortable: _vm.sortable,
                  width: "192"
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function(scope) {
                        return [
                          _c(
                            "router-link",
                            {
                              staticClass: "hover-underline blueColor",
                              attrs: {
                                to: {
                                  name:
                                    scope.row.document_type === "INVOICE"
                                      ? "invoice-detail"
                                      : scope.row.document_type ===
                                        "CREDIT_NOTE"
                                      ? "credit-note-detail"
                                      : scope.row.document_type === "DEBIT_NOTE"
                                      ? "debit-note-detail"
                                      : scope.row.document_type === "PAYMENT"
                                      ? "payment-document-detail"
                                      : "invoice-detail",
                                  params: {
                                    participant: _vm.selectedParticipantStore,
                                    reference: scope.row.reference
                                  }
                                }
                              },
                              nativeOn: {
                                click: function($event) {
                                  return $event.stopImmediatePropagation()
                                }
                              }
                            },
                            [
                              _vm._v(
                                "\n\t\t\t\t\t" +
                                  _vm._s(scope.row.document_number) +
                                  "\n\t\t\t\t"
                              )
                            ]
                          )
                        ]
                      }
                    }
                  ],
                  null,
                  false,
                  3772091111
                )
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.propsColumns.recipient === true
            ? _c("el-table-column", {
                attrs: {
                  label: _vm.$tc("recipient", 1),
                  "show-overflow-tooltip": "",
                  width: "192"
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function(scope) {
                        return "recipient_by_reference" in scope.row
                          ? [
                              _c(
                                "router-link",
                                {
                                  staticClass: "hover-underline blueColor",
                                  attrs: {
                                    to: {
                                      name: "recipient-detail",
                                      params: {
                                        participant:
                                          _vm.selectedParticipantStore,
                                        id:
                                          scope.row.recipient_by_reference &&
                                          scope.row.recipient_by_reference
                                            .reference
                                            ? scope.row.recipient_by_reference
                                                .reference
                                            : ""
                                      }
                                    }
                                  },
                                  nativeOn: {
                                    click: function($event) {
                                      return $event.stopImmediatePropagation()
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n\t\t\t\t\t" +
                                      _vm._s(
                                        scope.row.recipient_by_reference &&
                                          scope.row.recipient_by_reference.name
                                          ? scope.row.recipient_by_reference
                                              .name
                                          : "[Name N/A]"
                                      ) +
                                      "\n\t\t\t\t"
                                  )
                                ]
                              )
                            ]
                          : undefined
                      }
                    }
                  ],
                  null,
                  true
                )
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.legalEntityCount &&
          _vm.legalEntityCount > 1 &&
          _vm.propsColumns.legalEntity === true
            ? _c("el-table-column", {
                attrs: {
                  label: _vm.$tc("legalEntity"),
                  prop: "legal_entity_by_reference.registration_name",
                  "show-overflow-tooltip": "",
                  width: "192"
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function(scope) {
                        return [
                          _vm._v(
                            "\n\t\t\t\t" +
                              _vm._s(
                                scope.row.legal_entity_by_reference &&
                                  scope.row.legal_entity_by_reference
                                    .registration_name
                                  ? scope.row.legal_entity_by_reference
                                      .registration_name
                                  : ""
                              ) +
                              "\n\t\t\t"
                          )
                        ]
                      }
                    }
                  ],
                  null,
                  false,
                  4293314535
                )
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.propsColumns.status === true
            ? _c("el-table-column", {
                attrs: {
                  sortable: _vm.sortable,
                  align: "center",
                  label: _vm.$t("status"),
                  "show-overflow-tooltip": "",
                  prop: "status",
                  width: "192"
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function(scope) {
                        return [
                          _c(
                            "el-tag",
                            {
                              attrs: {
                                size: "mini",
                                type: _vm._f("risoltoStatusFilter")(
                                  _vm.computedStatus(
                                    scope.row.open_amount,
                                    scope.row.due_date
                                  )
                                )
                              }
                            },
                            [
                              _vm._v(
                                "\n\t\t\t\t\t" +
                                  _vm._s(
                                    _vm.$translate.invoice_status(
                                      _vm.computedStatus(
                                        scope.row.open_amount,
                                        scope.row.due_date
                                      )
                                    )
                                  ) +
                                  "\n\t\t\t\t"
                              )
                            ]
                          )
                        ]
                      }
                    }
                  ],
                  null,
                  false,
                  3004127866
                )
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.propsColumns.lastDunningStatus === true
            ? _c("el-table-column", {
                attrs: {
                  label: _vm.$t("lastDunningStatus"),
                  "show-overflow-tooltip": "",
                  width: "192"
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function(scope) {
                        return "dunning_status" in scope.row &&
                          (scope.row.dunning_status || {}).message_code
                          ? [
                              _c(
                                "a",
                                {
                                  staticClass: "hover-underline blueColor",
                                  attrs: { href: "javascript:;" },
                                  on: {
                                    click: function($event) {
                                      return _vm.handleActionItemClick(
                                        scope.row.dunning_status
                                      )
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n\t\t\t\t\t" +
                                      _vm._s(
                                        _vm.$translate.action_message_code(
                                          scope.row.dunning_status.message_code
                                        )
                                      ) +
                                      "\n\t\t\t\t"
                                  )
                                ]
                              )
                            ]
                          : undefined
                      }
                    }
                  ],
                  null,
                  true
                )
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.propsColumns.issueDate === true
            ? _c("el-table-column", {
                attrs: {
                  prop: "issue_date",
                  sortable: _vm.sortable,
                  label: _vm.$t("documentDate"),
                  "show-overflow-tooltip": "",
                  width: "128"
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function(scope) {
                        return [
                          scope.row.issue_date
                            ? [
                                _vm._v(
                                  "\n\t\t\t\t\t" +
                                    _vm._s(
                                      _vm._f("parseTime")(
                                        scope.row.issue_date,
                                        "{d}-{m}-{y}"
                                      )
                                    ) +
                                    "\n\t\t\t\t"
                                )
                              ]
                            : _vm._e()
                        ]
                      }
                    }
                  ],
                  null,
                  false,
                  3450238191
                )
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.propsColumns.dueDate === true
            ? _c("el-table-column", {
                attrs: {
                  prop: "due_date",
                  sortable: _vm.sortable,
                  label: _vm.$t("invoiceDueDate"),
                  "show-overflow-tooltip": "",
                  width: "128"
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function(scope) {
                        return [
                          scope.row.due_date
                            ? [
                                _vm._v(
                                  "\n\t\t\t\t\t" +
                                    _vm._s(
                                      _vm._f("parseTime")(
                                        scope.row.due_date,
                                        "{d}-{m}-{y}"
                                      )
                                    ) +
                                    "\n\t\t\t\t"
                                )
                              ]
                            : _vm._e()
                        ]
                      }
                    }
                  ],
                  null,
                  false,
                  692785391
                )
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.propsColumns.paidAtDate === true
            ? _c("el-table-column", {
                attrs: {
                  prop: "derived_paid_at",
                  label: _vm.$t("invoicePaidDate"),
                  "show-overflow-tooltip": "",
                  width: "128"
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function(scope) {
                        return [
                          scope.row.derived_paid_at
                            ? [
                                _vm._v(
                                  "\n\t\t\t\t\t" +
                                    _vm._s(
                                      _vm._f("parseTime")(
                                        scope.row.derived_paid_at,
                                        "{d}-{m}-{y}"
                                      )
                                    ) +
                                    "\n\t\t\t\t"
                                )
                              ]
                            : _vm._e()
                        ]
                      }
                    }
                  ],
                  null,
                  false,
                  1270209359
                )
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.propsColumns.totalAmount === true
            ? _c("el-table-column", {
                attrs: {
                  prop: "total_amount",
                  sortable: _vm.sortable,
                  label: _vm.$t("totalAmount"),
                  "show-overflow-tooltip": "",
                  align: "right",
                  width: "128"
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function(scope) {
                        return [
                          _vm._v(
                            _vm._s(
                              _vm.$formatter.toCurrency(
                                scope.row.total_amount,
                                scope.row.amount_currency
                              )
                            )
                          )
                        ]
                      }
                    }
                  ],
                  null,
                  false,
                  1762172067
                )
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.propsColumns.openAmount === true
            ? _c("el-table-column", {
                attrs: {
                  prop: "open_amount",
                  sortable: _vm.sortable,
                  label: _vm.$t("open"),
                  "show-overflow-tooltip": "",
                  align: "right",
                  width: "128"
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function(scope) {
                        return [
                          _vm._v(
                            _vm._s(
                              _vm.$formatter.toCurrency(
                                scope.row.open_amount,
                                scope.row.amount_currency
                              )
                            )
                          )
                        ]
                      }
                    }
                  ],
                  null,
                  false,
                  641494869
                )
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.propsColumns.pdf === true
            ? _c("el-table-column", {
                attrs: { align: "left", width: "48" },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function(scope) {
                        return _vm._l(scope.row.file_references, function(
                          file,
                          index
                        ) {
                          return _c(
                            "div",
                            { key: index, staticClass: "disp-inline" },
                            [
                              _c(
                                "el-tooltip",
                                {
                                  staticClass: "item",
                                  attrs: {
                                    effect: "dark",
                                    content: file.name,
                                    placement: "top"
                                  }
                                },
                                [
                                  _vm.isPdf(file)
                                    ? [
                                        _c("svg-icon", {
                                          staticClass: "fc-blue",
                                          staticStyle: {
                                            "font-size": "14px !important",
                                            "vertical-align": "middle"
                                          },
                                          attrs: {
                                            "icon-class": "file-invoice-solid"
                                          },
                                          on: {
                                            click: function($event) {
                                              return _vm.onClickDocIcon(file)
                                            }
                                          }
                                        })
                                      ]
                                    : _vm.isXml(file)
                                    ? [
                                        _c("svg-icon", {
                                          staticClass: "fc-blue",
                                          staticStyle: {
                                            "font-size": "14px !important",
                                            "vertical-align": "middle"
                                          },
                                          attrs: {
                                            "icon-class": "file-code-solid"
                                          },
                                          on: {
                                            click: function($event) {
                                              return _vm.onClickDocIcon(file)
                                            }
                                          }
                                        })
                                      ]
                                    : [
                                        _c("svg-icon", {
                                          staticClass: "fc-blue",
                                          staticStyle: {
                                            "font-size": "14px !important",
                                            "vertical-align": "middle"
                                          },
                                          attrs: {
                                            "icon-class": "file-code-solid"
                                          },
                                          on: {
                                            click: function($event) {
                                              return _vm.onClickDocIcon(file)
                                            }
                                          }
                                        })
                                      ]
                                ],
                                2
                              )
                            ],
                            1
                          )
                        })
                      }
                    }
                  ],
                  null,
                  false,
                  2473877359
                )
              })
            : _vm._e(),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              label: _vm.$t("InvoiceTable.dispute_until"),
              width: "128"
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "default",
                  fn: function(scope) {
                    return scope.row.invoice_dispute
                      ? [
                          scope.row.invoice_dispute.length > 0
                            ? _c("div", [
                                _c(
                                  "a",
                                  {
                                    staticClass: "hover-underline blueColor",
                                    attrs: { href: "javascript:;" },
                                    on: {
                                      click: function($event) {
                                        return _vm.handleInvoiceDisputeClick(
                                          scope.row.reference
                                        )
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n\t\t\t\t\t\t" +
                                        _vm._s(
                                          _vm._f("parseTime")(
                                            scope.row.invoice_dispute[0].until,
                                            "{d}-{m}-{y}"
                                          )
                                        ) +
                                        "\n\t\t\t\t\t"
                                    )
                                  ]
                                )
                              ])
                            : _vm._e()
                        ]
                      : undefined
                  }
                }
              ],
              null,
              true
            )
          }),
          _vm._v(" "),
          _vm.userInterfaceDetails &&
          _vm.userInterfaceDetails.custom_field_definitions &&
          _vm.userInterfaceDetails.custom_field_definitions.length > 0
            ? _vm._l(
                _vm.userInterfaceDetails.custom_field_definitions,
                function(custom_field_definition) {
                  return _c(
                    "el-table-column",
                    {
                      key: custom_field_definition.path,
                      attrs: { "show-overflow-tooltip": "", width: "192" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function(scope) {
                              return [
                                _c("custom-field-value", {
                                  attrs: {
                                    "custom-field-definition": custom_field_definition,
                                    "custom-fields": scope.row.custom_fields
                                  }
                                })
                              ]
                            }
                          }
                        ],
                        null,
                        true
                      )
                    },
                    [
                      _c(
                        "template",
                        { slot: "header" },
                        [
                          _c("custom-field-label", {
                            attrs: {
                              "custom-field-definition": custom_field_definition
                            }
                          })
                        ],
                        1
                      )
                    ],
                    2
                  )
                }
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.propsColumns.paymentReference === true
            ? _c("el-table-column", {
                attrs: {
                  label: _vm.$t("paymentReferenceShort"),
                  prop: "payment_reference",
                  sortable: _vm.sortable,
                  "show-overflow-tooltip": "",
                  width: "192"
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function(scope) {
                        return [_vm._v(_vm._s(scope.row.payment_reference))]
                      }
                    }
                  ],
                  null,
                  false,
                  732144083
                )
              })
            : _vm._e()
        ],
        2
      ),
      _vm._v(" "),
      _vm.total !== null
        ? _c(
            "div",
            [
              _c("pagination", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.total > 0,
                    expression: "total > 0"
                  }
                ],
                staticClass: "p-5",
                attrs: { total: _vm.total, page: _vm.page, limit: _vm.limit },
                on: {
                  "update:page": function($event) {
                    _vm.page = $event
                  },
                  "update:limit": function($event) {
                    _vm.limit = $event
                  },
                  pagination: _vm.getList
                }
              })
            ],
            1
          )
        : _c("div", {
            directives: [
              {
                name: "loading",
                rawName: "v-loading",
                value: true,
                expression: "true"
              }
            ],
            staticStyle: {
              "min-height": "20px",
              "margin-top": "17px",
              "font-size": "17px",
              float: "left"
            },
            attrs: {
              "element-loading-spinner": "el-icon-loading",
              "element-loading-background": "rgba(0, 0, 0, 0)"
            }
          }),
      _vm._v(" "),
      _vm.propsColumns.selection === true && _vm.fullRecipient
        ? _c(
            "div",
            [
              _c("dispute-dialog", {
                attrs: {
                  visible: _vm.disputeDialogVisible,
                  participant: _vm.selectedParticipantStore,
                  "legal-entity": _vm.fullRecipient.legal_entity,
                  recipient: _vm.fullRecipient.reference,
                  invoices: _vm.selectedInvoiceReferences
                },
                on: {
                  "dialog-close": function($event) {
                    _vm.disputeDialogVisible = false
                  },
                  confirm: _vm.handleInvoiceDisputeConfirm
                }
              }),
              _vm._v(" "),
              _c("invoice-disputes-dialog", {
                attrs: {
                  "legal-entity": _vm.fullRecipient.legal_entity,
                  recipient: _vm.fullRecipient.reference,
                  invoices: [_vm.selectedInvoice],
                  visible: _vm.invoiceDisputesDialogVisible
                },
                on: {
                  "dialog-close": function($event) {
                    _vm.invoiceDisputesDialogVisible = false
                  },
                  change: _vm.handleInvoiceDisputeChange
                }
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.propsColumns.selection === true && _vm.fullRecipient
        ? _c(
            "div",
            [
              _c("plan-manual-action-dialog", {
                attrs: {
                  visible: _vm.planManualActionDialogVisible,
                  recipient: _vm.fullRecipient.reference,
                  "legal-entity": _vm.fullRecipient.legal_entity,
                  invoices: _vm.selectedInvoices,
                  "dialog-close": () => {
                    _vm.planManualActionDialogVisible = false
                  }
                }
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c("attachment-templates-dialog", { ref: "attachmentTemplatesDialog" })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }